import axios from '@axios';

export default {
	namespaced: true,
	state: {},
	getters: {},
	mutations: {},
	actions: {
		fetchRequestBidders(ctx, queryParams) {
			return new Promise((resolve, reject) => {
				axios
					.get(`/request-bidders`, { params: queryParams })
					.then(response => resolve(response))
					.catch(error => reject(error));
			});
		},
	}
}